<bn-loading-overlay></bn-loading-overlay>
<div class="container mt-3 mx-auto">
  <div class="row">
    <div class="col">
      <h5>Patrimônio Líquido do Fundo {{estaEditando ? '(edição)' : '(cadastro)'}}</h5>
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-danger"
        bnConfirm
        tituloConfirm="Confirmação"
        msgConfirm="Descartar {{estaEditando ? 'edição' : 'novo cadastro'}} de Patrimônio Líquido?"
        (onConfirm)="limpar()">
        Cancelar
      </button>
      <button type="button" class="btn btn-primary" [disabled]="!formOk" (click)="salvar()"
          >Salvar
      </button>
    </div>
  </div>
  <div class="mt-3 row" [formGroup]="patrimonioForm">
      <div class="col-md-4 mt-3">
        <div class="col-md-10">
          <label for="data-base">Data Base*</label>
          <input type="text"
            class="form-control"
            [bnMask]="bnMaskDataBase"
            formControlName="dataBase"
            [placeholder]="placeHolderDataBase"
            required="required">
        </div>
      </div>
      <div class="col-md-8 mt-3 d-flex justify-content-end">
        <div class="col-md-12">
          <label for="valor-patrimonio-liquido">Valor Patrimônio Líquido*</label>
          <input id="valor-patrimonio-liquido"
            class="form-control moeda"
            bnMask="MOEDA"
            formControlName="valor"
            required="required">
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="col-md-12">
          <label for="data-registro">Data de Registro</label>
          <input id="usuarioResponsavel" class="form-control" [value]="dataHora" disabled>
        </div>
      </div>
      <div class="col-md-8 mt-3 d-flex justify-content-end">
        <div class="col-md-12">
          <label for="usuarioResponsavel">Usuário Responsável</label>
          <input id="usuarioResponsavel" class="form-control" [value]="nomeUsuarioResponsavel" disabled>
        </div>
      </div>
    </div>
</div>
